import React, { useContext } from 'react';

import { Step } from '../../types';

import { Modal } from 'app/design-system/components/Modal';
import { StepperContext } from 'app/design-system/components/Stepper/context';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import { GoogleRecaptchaV3Provider } from 'app/lib/google-recaptcha-v3';
import Stepper from 'app/widgets/Stepper';

import { AdultAge } from '../AdultAge';
import { SignBody, SignFooter } from '../SignModal';

const RE_CAPTCHA_KEY = getUniversalEnv('RE_CAPTCHA_KEY') || '';

import styles from './Signing.module.scss';

export const Signing = () => {
  const { activeStep } = useContext(StepperContext);

  return (
    <Stepper totalSteps={0}
             visibility={false}>
      <Modal.Body className={styles.container}>
        <GoogleRecaptchaV3Provider reCaptchaKey={RE_CAPTCHA_KEY}>
          <SignBody />
        </GoogleRecaptchaV3Provider>
      </Modal.Body>
      <SignFooter />
      { activeStep === Step.INITIAL && <AdultAge /> }
    </Stepper>
  );
};
